import {combineReducers} from '@reduxjs/toolkit';
import dateRange from './date-range.js';
import extent from './extent.js';
import filters from './filters.js';
import types from './types.js';

const reducer = combineReducers({
  extent,
  dateRange,
  filters,
  types,
});

export default reducer;
